import React from "react"

interface SeparatorProps extends React.ComponentPropsWithoutRef<'hr'> {}

export function Separator({ className = '', ...props }: SeparatorProps) {
  return (
    <hr
      aria-hidden
      className={`w-full border-t border-muted-foreground my-4 ${className}`}
      {...props}
    />
  )
}

export default Separator
